import { createReducer, on, Action } from '@ngrx/store';
import { PagedResultsOfJobSummary, JobListArgs } from 'src/shared/api';
import * as QuoteListActions from './quote-list.actions';

export const quoteListFeatureKey = 'quote-list';

export interface QuoteListState {
	isInitialized: boolean;
	isLoading?: boolean;
	listMessage?: string;
	listArgs?: JobListArgs;
	pagesResults?: PagedResultsOfJobSummary;
	error?: any;
}

export interface QuoteListPartialState {
	readonly [quoteListFeatureKey]: QuoteListState;
}

export const initialState: QuoteListState = {
	isInitialized: false,
	// additional entity state properties
};

const quotesReducer = createReducer(
	initialState,
	on(QuoteListActions.filtersUpdated, (state, { filters }) => ({
		...state,
		listArgs: filters,
		isLoading: true,
		isInitialized: true,
	})),
	on(
		QuoteListActions.pagedQuotesLoaded,
		(state, { pagedQuotes, listArgs }) => ({
			...state,
			listArgs,
			pagesResults: pagedQuotes,
			isLoading: false,
			isInitialized: true,
		})
	),
	on(QuoteListActions.errorLoadingQuotes, (state, { error }) => ({
		...state,
		error,
		isLoading: false,
		isInitialized: true,
	})),
	on(QuoteListActions.quoteListDestroyed, (state) => ({
		...state,
		pagesResults: { resultCount: 0, results: [], pageNumber: 0 },
		isInitialized: false,
	}))
);

export function reducer(state: QuoteListState | undefined, action: Action) {
	return quotesReducer(state, action);
}
